import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Select } from 'src/app/interface/select/select';
import { Organization } from 'src/app/beans/organization/organization.bean';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { User } from 'src/app/beans/login/user/user.bean';
import { MatSelectChange } from '@angular/material/select';

@Component({
  selector: 'organization-select',
  templateUrl: './organization.select.html',
  styleUrls: ['./organization.select.scss']
})
export class OrganizationSelect implements OnInit, OnChanges, Select
{
  @Input() autoSelectFirst: boolean = false

  @Input() enabled: number  = 1
  @Input() reload : boolean = false

  values: Organization[]
  currentValue: Organization

  @Output() change: EventEmitter<Organization> = new EventEmitter<Organization>()

  constructor
  (
    private _handler: HandlerManager,
    private _loader : LoadingManager,
    private _session: SessionManager,
  ) {}

  ngOnChanges(changes: SimpleChanges): void
  {
    if(changes)
    {
      if(this.reload)
      {
        this.init()
        this.reload = false
      }
    }
  }

  async ngOnInit()
  {
    this.init()
  }

  async init()
  {
    await this.retriveValues()

    if(this.setSavedValue(JSON.parse(localStorage.getItem('organization-select')))) {}
    else if (this.autoSelectFirst) this.selectFirst()
  }

  async checkRefresh()
  {
    if(localStorage.getItem('org-select-refresh') == "1")
    {
      localStorage.setItem('org-select-refresh', "0")
      await this.init()
    }
  }

  getSelectedValue() {
    return this.currentValue
  }

  setSelectedValue(value: Organization): void
  {
    this.currentValue = value
    this.change.emit(value)
  }

  clearSelectedValue(): void {
    this.currentValue = undefined
  }

  async retriveValues() {

    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    this._loader.start()

    let response = await this._handler.organization().list((user as User).token, this.enabled)

    this._loader.stop()

    if (!response) return

    const list = (response as any).list as Organization[]

    this.values = list

    this.values.sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1 : a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 0)

    return list
  }

  setSavedValue(org: Organization)
  {
    var control = false
    if(this.values && org)
    {
      this.values.forEach(element => {
        if(element.id == org.id)
        { this.setSelectedValue(element)
          control = true
        }
      });
    }
    return control
  }

  selectFirst(): void
  {
    if(this.values && this.values.length > 0)
    {
      this.currentValue = this.values[0]
      this.change.emit(this.currentValue)
    }
  }

  selectElement(el: Organization): void {
    const find = this.searchElement(el)
    if (find) this.currentValue = find
  }

  searchElement(el: Organization): Organization {
    if (!this.values) return undefined

    return this.values.find((org) => org.id == el.id)
  }

  refreshData()
  {
    this.init()
  }

  onChange(slChange: MatSelectChange)
  {
    this.setSelectedValue(slChange.value)
    localStorage.setItem('organization-select', JSON.stringify(slChange.value))
  }
}
